import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addSalesOrder = catchAsync(async (body) => {
  const { data } = await axiosInstance.post('/api/resource/Sales Order', body);
  return data;
});
export const updateSalesOrder = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Sales Order/${id}`,
    body
  );
  return data;
});

export const getSalesOrder = catchAsync(async ({ key = '', value = '' }) => {
  let baseUrl =
    '/api/resource/Sales Order?fields=["name", "customer", "total", "base_total_taxes_and_charges", "status","docstatus", "advance_paid"]&order_by=name desc&limit_start=0&limit_page_length=0';
  if (value) {
    baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
  }
  const { data } = await axiosInstance.get(baseUrl);
  return data;
});
export const deleteSalesOrder = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Sales Order/${record}`
  );
  return data;
});
export const getSalesOrderById = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Sales Order/${id}`);
  return data;
});
export const getSalesOrderDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.map_reference?target=SO MR&source=${id}`
  );
  return data;
});
export const createPartialSalesInvoice = catchAsync(async (id, amount) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.create_partial_sales_invoice_from_order?name=${id}&amount=${amount}`
    // `/api/method/technoerp.services.create_partial_sales_invoice_from_order?name=${id}`
  );
  return data;
});
export const createFullInvoice = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.create_full_invoice_from_sales_order?name=${id}`
  );
  return data;
});
export const getSalesOrderDetailsPaymentEntry = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_PE_details?type=Sales Order&name=${id}`
  );
  return data;
});
